import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { COMPANY, SERVICES, LOGO, GROUPE_DIPLOMATE_LOGO } from "../constants/data";
import { PRIMARY_LOCALITY_LIST } from "../constants/locals";

export const Footer = () => (
  <footer className="border-t border-[#262626] bg-[#0A0A0A]" data-testid="footer">
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
      <div className="md:col-span-3">
        <Link to="/" className="inline-flex items-center mb-5">
          <span className="bg-white rounded-sm p-2.5 inline-flex">
            <img src={LOGO} alt="Vision Démolition" loading="lazy" decoding="async" className="h-16 w-auto" />
          </span>
        </Link>
        <p className="text-gray-400 text-sm leading-relaxed max-w-xs">
          Plateforme de démolition professionnelle. Des projets résidentiels aux travaux industriels — organisation, rapidité et force d'exécution.
        </p>
      </div>

      <div className="md:col-span-2">
        <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-primary mb-4">Services</h4>
        <ul className="space-y-2.5">
          {SERVICES.slice(0, 5).map((s) => (
            <li key={s.slug}><Link to="/services" className="text-gray-400 hover:text-white text-sm transition-colors duration-200">{s.title}</Link></li>
          ))}
        </ul>
      </div>

      <div className="md:col-span-3">
        <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-primary mb-4">Régions desservies</h4>
        <ul className="space-y-2.5">
          {PRIMARY_LOCALITY_LIST.map((l) => (
            <li key={l.slug}><Link to={`/${l.slug}`} className="text-gray-400 hover:text-white text-sm transition-colors duration-200" data-testid={`footer-region-${l.slug}`}>Démolition {l.region}</Link></li>
          ))}
        </ul>
      </div>

      <div className="md:col-span-2">
        <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-primary mb-4">Plateforme</h4>
        <ul className="space-y-2.5">
          <li><Link to="/projets" className="text-gray-400 hover:text-white text-sm transition-colors duration-200">Projets</Link></li>
          <li><Link to="/blog" className="text-gray-400 hover:text-white text-sm transition-colors duration-200">Blogue</Link></li>
          <li><Link to="/a-propos" className="text-gray-400 hover:text-white text-sm transition-colors duration-200">À propos</Link></li>
          <li><Link to="/soumission" className="text-gray-400 hover:text-white text-sm transition-colors duration-200">Soumission</Link></li>
          <li><Link to="/admin" className="text-gray-400 hover:text-white text-sm transition-colors duration-200">Tableau de bord</Link></li>
        </ul>
      </div>

      <div className="md:col-span-2">
        <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-primary mb-4">Contact</h4>
        <ul className="space-y-3 text-sm text-gray-400">
          <li className="flex items-center gap-3"><Phone className="w-4 h-4 text-primary shrink-0" /><a href={COMPANY.phoneHref} className="hover:text-white">{COMPANY.phone}</a></li>
          <li className="flex items-center gap-3"><Mail className="w-4 h-4 text-primary shrink-0" /><a href={`mailto:${COMPANY.email}`} className="hover:text-white">{COMPANY.email}</a></li>
          <li className="flex items-start gap-3"><MapPin className="w-4 h-4 text-primary shrink-0 mt-0.5" /><span>{COMPANY.region}</span></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-[#262626]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-8 flex flex-col items-center gap-3 text-center" data-testid="groupe-diplomate">
        <img src={GROUPE_DIPLOMATE_LOGO} alt="Groupe Diplomate" loading="lazy" decoding="async" className="h-16 w-auto rounded-sm" />
        <p className="text-xs text-gray-400 uppercase tracking-[0.15em]">
          Vision Démolition est une division de <span className="text-white font-semibold">Groupe Diplomate</span>
        </p>
        <p className="text-xs text-gray-500">1000, rue Fleury Est, Montréal, Québec H2C 1P7</p>
        <p className="text-xs text-gray-500">RBQ&nbsp;: 5669-2171-01 (Groupe Diplomate)</p>
      </div>
    </div>
    <div className="border-t border-[#262626]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
        <p className="text-xs text-gray-500">© {new Date().getFullYear()} {COMPANY.name}. Tous droits réservés.</p>
        <p className="text-xs text-gray-500 uppercase tracking-wider">Grand Montréal · Québec · Canada</p>
      </div>
    </div>
  </footer>
);
